import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import * as librariesApi from '@motionelements/core/src/api/libraries.js';

const DefaultCurationMember = {
  id: 'motionelements',
  hashId: 'm_kOaxYNB',
  avatar: {
    url: 'https://static.moele.me/img/logo/MotionElements-logomark-square-512x512-220622.png',
  },
  username: 'MotionElements',
};

const state = {
  followedMembers: [],
  loading: false,
};

const getters = {
  allFollowedMembers(state) {
    return [DefaultCurationMember, ...state.followedMembers];
  },
};

const actions = {
  listFollowedMembers({ commit }) {
    commit('setLoading', true);
    return librariesApi.getLibraries()
      .then((response) => {
        commit('setFollowedMembers', response.data.data);
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setFollowedMembers(state, members) {
    state.followedMembers = members;
  },
  //
  filterFollowedMembers(state) {
    // eslint-disable-next-line
    const filteredMembers = state.followedMembers.filter(member => Object.keys(member).includes('followedAt') && member.followedAt);
    state.followedMembers = filteredMembers;
  },
  addFollowedMember(state, member) {
    const index = getters.allFollowedMembers(state).findIndex(x => x.hashId === member.hashId);
    if (index < 0) {
      state.followedMembers.push(member);
    }
  },
  updateFollowedMember(state, member) {
    const index = state.followedMembers.findIndex(x => x.hashId === member.hashId);
    if (index < 0) {
      state.followedMembers.push(member);
    } else {
      state.followedMembers.splice(index, 1, member);
    }
  },
  followMember(state, hashId) {
    const targetMember = state.followedMembers.find(x => x.hashId === hashId);
    if (targetMember) targetMember.followedAt = Math.round(new Date() / 1000);
  },
  unfollowMember(state, hashId) {
    const targetMember = state.followedMembers.find(x => x.hashId === hashId);
    if (targetMember && _.get(targetMember, 'followedAt')) targetMember.followedAt = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: { ...mutations, ...loadingMutation },
};
